import { gql, useQuery } from '@apollo/client';
import { Alert, Flex, Text } from '@mantine/core';
import { IconNotification } from '@tabler/icons-react';
import { Link } from '@tanstack/react-router';
import { useMemo } from 'react';

export const RenewalAlert = () => {
	const today = useMemo(() => new Date(), []);
	const todayFormatted = today.toISOString().split('T')[0];
	const nextMonth = new Date(today.getTime());
	nextMonth.setMonth(nextMonth.getMonth() + 1);
	const nextMonthFormatted = nextMonth.toISOString().split('T')[0];

	const { data, loading } = useQuery<{
		userSubscriptions: {
			validTo: string;
		}[];
	}>(
		gql`
			query UserSubscriptions($filter: UserSubscriptionsListFilter) {
				userSubscriptions(filter: $filter) {
					validTo
				}
			}
		`,
		{
			variables: {
				filter: {
					_and: [
						{
							validFrom_lte: todayFormatted,
							validTo_gte: todayFormatted,
						},
						{
							validTo_lte: nextMonthFormatted,
						},
					],
				},
			},
		}
	);

	const daysLeft = useMemo(() => {
		if (!data?.userSubscriptions?.[0]?.validTo) return 0;

		return Math.ceil(
			(new Date(data.userSubscriptions[0].validTo).getTime() - today.getTime()) /
				(1000 * 60 * 60 * 24)
		);
	}, [data?.userSubscriptions, today]);

	if (loading) return null;

	if (!data?.userSubscriptions || data?.userSubscriptions.length === 0) return null;

	return (
		<Alert variant="filled" color="red" title="Subscription Renewal" icon={<IconNotification />}>
			<Flex direction="column" gap="sm">
				<Text size="sm">
					Your subscription will expire in {daysLeft} {daysLeft === 1 ? 'day' : 'days'}
					<br />
					<Link to="/choose-subscription">You can renew it here.</Link>
				</Text>
			</Flex>
		</Alert>
	);
};
